import { render, staticRenderFns } from "./MediosTable.vue?vue&type=template&id=2fbea524&scoped=true"
import script from "./MediosTable.vue?vue&type=script&lang=js"
export * from "./MediosTable.vue?vue&type=script&lang=js"
import style0 from "./MediosTable.vue?vue&type=style&index=0&id=2fbea524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbea524",
  null
  
)

export default component.exports